import React, { FC } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { UserInput } from "../../validations/userCreateValidation";
import { useTheme } from "@carrier-io/air-react/styles";
import Box from "@carrier-io/air-react/Box";
import { CreateUserHead } from "../createUser/CreateUserHead";
import Stack from "@carrier-io/air-react/Stack";
import { ControllableInput } from "../controllable/Input";

interface UpdateProfileInformation {
  control: Control<UserInput>;
  errors?: Pick<FieldErrors<UserInput>, "firstName" | "lastName">;
}

export const UpdateProfileInformation: FC<UpdateProfileInformation> = ({
  control,
  errors,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        paddingBottom: 3,
        marginBottom: 3,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <CreateUserHead
        title="Update your information"
        description="How your name appears to you and your team members"
      />
      <Box>
        <Stack direction="row" spacing={1} sx={{ marginBottom: 2 }}>
          <ControllableInput
            control={control}
            data-testid="firstName"
            name="firstName"
            label="First Name"
            error={errors?.firstName?.message}
            required
            showBorder
            hideBackgroundColor
            size="xlarge"
            sx={{ width: "100%", minWidth: "220px", maxWidth: "240px" }}
          />
          <ControllableInput
            control={control}
            name="lastName"
            label="Last Name"
            data-testid="lastName"
            error={errors?.lastName?.message}
            required
            showBorder
            hideBackgroundColor
            size="xlarge"
            sx={{ width: "100%", minWidth: "220px", maxWidth: "240px" }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
